import { ApolloCache } from "@apollo/client"

import {
  RoomPriceFragment,
  RoomPriceFragmentDoc
} from "shared/api/price/fragments.generated"
import { RoomPriceTypeName } from "shared/types/Price"

export function readRoomPriceFragment(id: string, cache: ApolloCache<object>) {
  const cacheId = cache.identify({ id, __typename: RoomPriceTypeName })
  if (!cacheId) return null
  return cache.readFragment<RoomPriceFragment>(
    {
      id: cacheId,
      fragment: RoomPriceFragmentDoc
    },
    true
  )
}
